var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-page client" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          { staticClass: "col-12 form-page px-md-5" },
          [
            _c("marketing-list-header", {
              attrs: {
                creating: _vm.creating,
                "list-name": _vm.listToEdit.name,
                "creating-list": _vm.creatingList,
                "updating-list": _vm.updatingList,
                "deleting-list": _vm.deletingList,
                "back-path": _vm.backPath,
                validator: _vm.$v,
              },
              on: { submit: _vm.handleSubmit, "delete-list": _vm.deleteList },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card mortgage mt-sm-0 mt-4" },
              [
                !_vm.creating
                  ? _c(
                      "div",
                      { staticClass: "nav-tabs-wrapper position-static" },
                      [
                        _c(
                          "ul",
                          { staticClass: "nav nav-tabs scroll-container" },
                          [
                            _c("li", { staticClass: "nav-item dropdown-nav" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "bold text-grey dropdown-toggle",
                                  attrs: {
                                    id: "manage-contacts",
                                    href: "#",
                                    role: "button",
                                    "data-toggle": "dropdown",
                                    "aria-haspopup": "true",
                                    "aria-expanded": "false",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("lists.manageContacts")) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "dropdown-menu",
                                  attrs: {
                                    "aria-labelledby": "manage-contacts",
                                    "x-placement": "bottom-start",
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item clickable",
                                      on: { click: _vm.viewContacts },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "lists.segments.viewContacts"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item clickable export-contacts",
                                      on: { click: _vm.exportContacts },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "lists.segments.exportContacts"
                                            )
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    { staticClass: "dropdown-item d-none" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t("global.actions.viewDetails")
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    { staticClass: "dropdown-item d-none" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "lists.segments.viewSegments"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "dropdown-item clickable text-danger btn-danger delete-contacts",
                                      attrs: {
                                        "data-toggle": "modal",
                                        "data-target": "#delete-contacts-modal",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$t(
                                              "lists.messages.deleteAllContacts"
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "li",
                              {
                                staticClass: "nav-item dropdown-nav",
                                attrs: { id: "client-profile-details" },
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "bold text-grey dropdown-toggle",
                                    attrs: {
                                      id: "add-contacts",
                                      href: "#",
                                      role: "button",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("lists.addContacts")) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "dropdown-menu hide-on-click",
                                    attrs: {
                                      "aria-labelledby": "add-contacts",
                                      "x-placement": "bottom-start",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item clickable",
                                        on: { click: _vm.handleImportContacts },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "lists.segments.importContacts"
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "dropdown-item clickable",
                                        on: { click: _vm.handleAddManually },
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.$t(
                                                "lists.segments.addManually"
                                              )
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "modal fade",
                    attrs: {
                      id: "delete-contacts-modal",
                      tabindex: "-1",
                      role: "dialog",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "modal-dialog modal-dialog-centered",
                        attrs: { role: "document" },
                      },
                      [
                        _c("div", { staticClass: "modal-content" }, [
                          _c("div", { staticClass: "modal-header" }, [
                            _c("h5", { staticClass: "modal-title" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("lists.messages.deleteAllContacts")
                                  ) +
                                  "\n                  "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._m(0),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "modal-body" }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "lists.messages.confirmDeleteAllContacts"
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "modal-footer" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-white",
                                  attrs: {
                                    type: "button",
                                    "data-dismiss": "modal",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("global.words.no")) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "simple-button",
                                {
                                  attrs: {
                                    id: "delete-button",
                                    "class-name": "btn btn-danger",
                                    type: "danger",
                                    loading: _vm.deletingAllContacts.loading,
                                    "loading-succeeded":
                                      _vm.deletingAllContacts.status,
                                  },
                                  on: { click: _vm.deleteContacts },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("global.messages.yesRemoveAll")
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.loading
                  ? _c("list-details-loader")
                  : _c("marketing-list-details", {
                      attrs: {
                        creating: _vm.creating,
                        "current-list": _vm.listToEdit,
                        "fields-visibility": _vm.fieldsVisibility,
                        "import-contacts": _vm.importContacts,
                      },
                      on: { change: _vm.handleChange },
                    }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }